<template>
    <div class="pb-16 pb-md-20">
        <v-row v-for="{ term, desc, list, type } in classifications" :key="term.en" no-gutters class="mt-16 mt-md-20">
            <v-col cols="12" sm="5" md="12" lg="5">
                <div class="mb-8 mb-sm-0 mb-md-8 mb-lg-0">
                    <div class="d-inline-block d-sm-block font-size-14 font-size-md-16 font-weight-bold primary--text">{{ term.ko }}</div>
                    <div class="d-inline-block d-sm-block font-size-14 font-weight-light grey-68--text pl-6 pl-sm-0">{{ term.en }}</div>
                </div>
            </v-col>
            <v-col cols="12" sm="7" md="12" lg="7">
                <template v-if="type == NULL.value">
                    <span class="font-size-14">데이터가 없습니다.</span>
                </template>
                <template v-if="type == DESC.value">
                    <span class="font-size-14">{{ desc }}</span>
                </template>
                <template v-if="type == LIST.value">
                    <v-row class="row--xx-small" style="pointer-events: none">
                        <v-col v-for="{ term, isIt } in list" :key="term" :cols="list.length > 2 ? 4 : 12">
                            <template v-if="isIt">
                                <v-chip outlined color="grey-cb" text-color="primary" class="rounded-0 w-100 pa-0 justify-center" style="height:26px;">{{ term }}</v-chip>
                            </template>
                            <template v-else>
                                <v-chip color="grey-ef" text-color="grey" class="rounded-0 w-100 pa-0 justify-center" style="height:26px;">{{ term }}</v-chip>
                            </template>
                        </v-col>
                    </v-row>
                </template>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { WORK_CLASSIFICATION_TYPES } from "@/assets/variables";
const { NULL, DESC, LIST } = WORK_CLASSIFICATION_TYPES;
export default {
    props: ["classifications"],
    data: () => ({
        NULL,
        DESC,
        LIST,
    }),
};
</script>

<style lang="scss" scoped>

</style>